import "../component_style/contect.css"
import email from "../image/gmail.png"
import phone from "../animated_image/phone.gif"
import linkiden from "../animated_image/linkiden.gif"
import github from "../image/github.svg"


export default function Contect (){
    return(
        <div className="about_contect">
             {/* <h1 Style={"color:black"} >About</h1> */}
            <div className="about_content" >

            <h2 className="contect_head" ><b>Get in Touch</b></h2>
            <br/>
            <p Style={"color: aliceblue;"}>Thanks for stopping by, If you think I might be a good fit for Your Organization, give me a call or send me an email 📧.</p>
            <div className="Contect_icon">
           <a href="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=nikhilwalwatkar81@gmail.com" target="blank"><img id="static_icons" src={email}/></a> 
           <a href="tel:7558617259" ><img src={phone}/></a> 
            <a href="https://www.linkedin.com/in/nikhil-walwatkar-898684183/" target="blank"><img src={linkiden}/></a>
            <a href="https://github.com/Nikhil-81" target="blank"><img id="static_icons" src={github}/></a>
                
                </div>

        </div>
        </div>

    )
}